module.exports = __webpack_public_path__ + "c60cad17addb9f2a8a75d56c44cb9a29.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/file_upload.svg
// module id = 1thR
// module chunks = 1